import { Component } from '@angular/core';
import { ConfigService } from 'src/app/config.service';
import { SettingsService } from 'src/app/settings/settings.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  serverVersion = 'x.x.x';
  version = 'x.x.x';

  constructor(private settingsService: SettingsService, private configService: ConfigService) {
    this.version = this.configService.configData.appVersion;
    this.settingsService.getServerVersion().subscribe(
      version => {
        this.serverVersion = version.number;
      }
    );
  }

}
